import React from "react";

const fmt = (n) => (n == null ? "—" : Number(n.toFixed(3)).toLocaleString("lt-LT", { maximumFractionDigits: 3 }));

const Item = ({ id, label, value }) => (
    <span data-testid={`stat-${id}`} className="whitespace-nowrap">
        <span className="text-slate-500">{label}:</span> <span className="text-slate-200 font-semibold">{value}</span>
    </span>
);

// Excel-like status bar statistics for the selected cells.
export function SelectionStats({ stats, t }) {
    if (!stats) return null;
    const numeric = stats.numCount > 0;
    return (
        <div data-testid="selection-stats" className="flex items-center gap-4 flex-wrap justify-end">
            {numeric ? (
                <>
                    <Item id="count" label={t("st_count")} value={stats.numCount} />
                    <Item id="sum" label={t("st_sum")} value={fmt(stats.sum)} />
                    <Item id="avg" label={t("st_avg")} value={fmt(stats.avg)} />
                    <Item id="min" label="Min" value={fmt(stats.min)} />
                    <Item id="max" label="Max" value={fmt(stats.max)} />
                </>
            ) : (
                <>
                    <Item id="cells" label={t("st_cells")} value={stats.cells} />
                    <Item id="filled" label={t("st_filled")} value={stats.filled} />
                    <Item id="empty" label={t("st_empty")} value={stats.empty} />
                </>
            )}
        </div>
    );
}
